'use strict'

import L from 'leaflet';
import Map from '../../providers/map-singleton';
import HttpService from '../../providers/http-service.js';
import moment from 'moment';
import { getConfig } from '../../config';

class RouteClusterPopup extends L.Popup {
    constructor(title, data, latLng, map, oid) {
        super();
        this.map = map;
        this.setLatLng(latLng);
        this.config = getConfig();
        this.title = title;
        this.items = [];
        this.httpService = new HttpService();
        this.oid = oid;
        let segments = [...new Set(data.map(item => item.getClusterType()))];
        for (var index = 0; index < segments.length; index++) {
            this.items.push({
                objects: data.filter(item => item.getClusterType() === segments[index]),
                type: segments[index],
                isOpen: false
            });
        }
        this.on('popupclose', () => { });
        this.initSize(this.config);
        this.options.className = 'fort-map-popup';
        this.markup = this._getMarkup();

        this.setContent(this.markup);
        this.openOn(this.map);
        for (let index = 0; index < segments.length; index++) {
            document.getElementById('route-cluster-' + segments[index] + '-' + this.oid)
                .getElementsByClassName("group-items-header")[0]
                .onclick = this.clickGroup.bind(this, segments[index], oid);
        }

        for (let item of data) {
            document.getElementsByClassName('route-cluster-item-' + item.getGroupName() + '-' + item.getTimeForCluster())[0]
                .onclick = this.clickItem.bind(this, item);
        }
        document.getElementsByClassName('route-cluster-popup-back')[0].onclick = this.clickBack;
    }

    initSize(config) {
        this.options.minWidth = config.popup.minWidth;
        this.options.maxHeight = config.popup.maxHeight;
    }

    clickBack() {
        let targetDiv3 = document.getElementsByClassName("route-cluster-popup-back")[0];

        targetDiv3.classList.add("displayNone");
        let targetDiv = document.getElementsByClassName("route-cluster-popup-container-group")[0];
        targetDiv.classList.remove("displayNone");

        var targetDiv2 = document.getElementById('route-cluster-popup-container').getElementsByClassName("item-info")[0];
        targetDiv2.parentNode.removeChild(targetDiv2);
    }

    clickItem(item) {
        let latLng = item.getLatLng();
        this.httpService.getInfoForPopupPointOnMap(latLng, item.oid)
            .then((data) => {
                item.initPopup(data);
                let itemPopupMarkup = item.popup._getMarkup();
                var targetDiv = document.getElementsByClassName("route-cluster-popup-container-group")[0];
                targetDiv.classList.add("displayNone");
                var targetDiv2 = document.getElementsByClassName("route-cluster-popup-container")[0];
                targetDiv2.insertAdjacentHTML('beforeend', itemPopupMarkup);
                let targetDiv3 = document.getElementsByClassName("route-cluster-popup-back")[0];
                targetDiv3.classList.remove("displayNone");
            })
            .catch(err => { });
    }

    clickGroup(segment, oid, event) {
        for (let group of this.items) {
            if (group.type === segment) {
                if (group.isOpen) {
                    var targetDiv = document.getElementById('route-cluster-' + segment + '-' + oid)
                        .getElementsByClassName("expander")[0];
                    targetDiv.classList.remove("icon-20");
                    targetDiv.classList.add("icon-19");
                    group.isOpen = false;
                    let targetDiv2 = document.getElementById('route-cluster-' + segment + '-' + oid)
                        .getElementsByClassName("group-items")[0];
                    targetDiv2.classList.add("displayNone");
                }
                else {
                    var targetDiv = document.getElementById('route-cluster-' + segment + '-' + oid)
                        .getElementsByClassName("expander")[0];
                    targetDiv.classList.remove("icon-19");
                    targetDiv.classList.add("icon-20");
                    let targetDiv2 = document.getElementById('route-cluster-' + segment + '-' + oid)
                        .getElementsByClassName("group-items")[0];
                    targetDiv2.classList.remove("displayNone");
                    group.isOpen = true;
                }
            }
        }
    }

    _getMarkup() {
        return `
            <div class="route-cluster-popup-container" id="route-cluster-popup-container">
                <div class="route-cluster-popup-back displayNone" style="color: #00a2d0; font-family: 'Roboto Light'; position: absolute;top: 10px; display: flex; align-items: center; cursor:pointer; z-index:100">
                    <i class="fas fa-angle-left coloricon" style="font-family: fontawesome; font-size: 34px; font-style: initial; margin-right: 10px;"></i>
                    ${messages['Back']}
                </div>      
                <div class="route-cluster-popup-container-group x-panel x-border-item" style="margin: 45px 0px 0px 0px; height: calc(100% - 35px); max-height: 400px; overflow-y: auto;">
                    <div class="popup-title" style="text-align: center; text-align: center; position: fixed; z-index: 100; font-family: 'Roboto Regular'; top: 15px; width:100%">
                        ${messages['ElementsList']}
                    </div>  
                    <div class="x-panel-body x-panel-body-default x-panel-body-default x-noborder-trbl">
                        <div class="x-grid-with-row-lines x-panel-body-default x-panel-body-default x-noborder-trbl">
                            <div class="x-grid-view x-grid-with-row-lines x-fit-item x-grid-view-default" style="padding: 10px 0px 15px 0px;">
                                ${this.items.map(item => this._renderGroup(item)).join('')}                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        `;
    }

    _renderGroup(item) {
        return `
            <div class="x-grid-item-container" id="${'route-cluster-' + item.type + '-' + this.oid}">
                <table class="group-items-header" style="width: 100%;">          
                    <tbody>    
                        <tr style="border-bottom: 1px solid #d0d0d0;">
                            <td class="x-grid-cell x-grid-td x-grid-cell-gridcolumn-1052" style="width:30px; display: block; margin-top: 5px; color: #11a8d3;">
                                <div class="expander icon-19" role="presentation"></div>
                            </td>             
                            <td class="x-grid-cell x-grid-td x-grid-cell-gridcolumn-1052" style="width: 30px; display: block;">
                                <div class="x-grid-cell-inner" style="text-align:left;">
                                    ${item.objects[0]._getStatusIcon()}
                                </div>
                            </td>
                            <td class="x-grid-cell x-grid-td x-grid-cell-gridcolumn-1054" style="width: 40px; display: block;">
                                <div class="countObject" style="margin-left: 5px;">
                                    ${item.objects.length}
                                </div>
                            </td>
                            <td class="x-grid-cell x-grid-td x-grid-cell-gridcolumn-1054" style="width: 185px; display: block;">
                                <div class="x-grid-cell-inner" style="text-align: left; color: #a5a0a0; margin-left: 10px;">
                                    ${item.objects[0].getGroupName()}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="x-grid-item-container group-items displayNone">
                    <table style="width: 100%;">          
                        <tbody>     
                            <tr class="object-info-row  x-grid-row cluster-item">
                                <td class="x-grid-cell x-grid-td x-grid-cell-gridcolumn-1052" style="width: 50%; display: block;">
                                    <div class="x-grid-cell-inner" style="text-align: left;">
                                        ${item.objects[0].getTimeTitleForCluster()}
                                    </div>
                                </td>
                                <td class="x-grid-cell x-grid-td x-grid-cell-actioncolumn-1053  x-action-col-cell" style="width: 50%; display: flex; align-items: center; justify-content: center;">
                                    <div class="x-grid-cell-inner" style="text-align: center;">
                                        ${item.objects[0].getInfoTitleForCluster()}
                                    </div>
                                </td>          
                            </tr>
                            ${item.objects.sort(function (a, b) {
                                return new Date(a.getTimeForCluster()) - new Date(b.getTimeForCluster());
                            }).map(item => this._renderRow(item)).join('')}
                        </tbody>
                    </table>
                </div>
            </div>
        `;
    }

    _renderRow(item) {
        return `
            <tr class="object-info-row x-grid-row ${'route-cluster-item-' + item.getGroupName() + '-' + item.getTimeForCluster()}" style="cursor:pointer">
                <td class="x-grid-cell x-grid-td x-grid-cell-gridcolumn-1052" style="width: 50%; display: block;">
                    <div class="x-grid-cell-inner" style="text-align: left;">
                        ${moment(fmtools.getLocalDateTime(item.getTimeForCluster())).format(messages['moment_data_time_format'])}
                    </div>
                </td>
                <td class="x-grid-cell x-grid-td x-grid-cell-actioncolumn-1053 x-action-col-cell" style="width: 50%; display: flex; align-items: center; justify-content: center;">
                    <div class="x-grid-cell-inner" style="text-align: center;">
                        ${item.getInfoForCluster()}
                    </div>
                </td>
            </tr>
        `;
    }

    _getFooter(footerMsg) {
        return footerMsg;
    }
}

export default RouteClusterPopup;
